import { Field } from 'devextreme/ui/pivot_grid/data_source';
import { adat_tipus_group, termekek_group } from './common';

export const dimensiondata_3_dimension_1: Field = {
  dataField: 'dimensiondata_3.label',
  sortBy: 'none',
  wordWrapEnabled: true,
  isMeasure: false,
};

export const dimensiondata_3_dimension_2: Field = {
  ...dimensiondata_3_dimension_1,
  dataField: 'dimensiondata_3.child.label',
};

export const dimensiondata_3_dimension_3: Field = {
  ...dimensiondata_3_dimension_1,
  dataField: 'dimensiondata_3.child.child.label',
};

export const dimensiondata_3_termekek: Field[] = [
  { ...dimensiondata_3_dimension_1, groupName: 'termekek', groupIndex: 0 },
  { ...dimensiondata_3_dimension_2, groupName: 'termekek', groupIndex: 1 },
  { ...dimensiondata_3_dimension_3, groupName: 'termekek', groupIndex: 2 },
];

export const dimensiondata_3_adat_tipus: Field[] = [
  { ...dimensiondata_3_dimension_1, groupName: 'adat_tipus', groupIndex: 0 },
  { ...dimensiondata_3_dimension_2, groupName: 'adat_tipus', groupIndex: 1 },
  { ...dimensiondata_3_dimension_3, groupName: 'adat_tipus', groupIndex: 2 },
];

export const dimensiondata_3_termekek_group_row: Field[] = [
  {
    ...termekek_group,
    area: 'row',
  },
  ...dimensiondata_3_termekek,
];

export const dimensiondata_3_termekek_group_column: Field[] = [
  {
    ...termekek_group,
    area: 'column',
  },
  ...dimensiondata_3_termekek,
];

export const dimensiondata_3_termekek_group_column_expanded: Field[] = [
  {
    ...termekek_group,
    area: 'column',
    expanded: true,
  },
  ...dimensiondata_3_termekek,
];

export const dimensiondata_3_adat_tipus_group_column: Field[] = [
  {
    ...adat_tipus_group,
    area: 'column',
  },
  ...dimensiondata_3_adat_tipus,
];

export const dimensiondata_3_dimension_1_filter: Field[] = [
  {
    ...adat_tipus_group,
    area: 'filter',
  },
  {
    ...dimensiondata_3_dimension_1,
    groupName: 'adat_tipus',
    groupIndex: 0,
  },
];

export const dimensiondata_3_dimension_1_import_filter: Field[] = [
  {
    ...adat_tipus_group,
    area: 'filter',
    filterValues: [['Import']],
  },
  {
    ...dimensiondata_3_dimension_1,
    groupName: 'adat_tipus',
    groupIndex: 0,
  },
];
